/* Frequently bought together (sections/tv-bought-together.liquid).
   Keeps the total in sync with the ticked items / chosen variants, follows the
   page's variant picker for the main item, and adds everything ticked in one
   /cart/add request, then opens the cart drawer like every other add button. */
(function () {
  function init(root) {
    if (!root || root.dataset.tvfbtReady) return;
    root.dataset.tvfbtReady = '1';

    var fmt;
    try {
      fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }
    function money(cents) { return fmt.format(cents / 100); }

    var items = [].slice.call(root.querySelectorAll('[data-tvfbt-item]'));
    var totalEl = root.querySelector('[data-tvfbt-total]');
    var wasEl = root.querySelector('[data-tvfbt-was]');
    var btn = root.querySelector('[data-tvfbt-add]');
    var label = root.querySelector('[data-tvfbt-label]');
    var msg = root.querySelector('[data-tvfbt-msg]');
    var labelTpl = label.textContent;

    function chosen() {
      return items.filter(function (li) { return li.querySelector('[data-tvfbt-toggle]').checked; });
    }

    function update() {
      var sel = chosen(), now = 0, was = 0;
      sel.forEach(function (li) { now += +li.dataset.price; was += +li.dataset.compare; });
      items.forEach(function (li) { li.classList.toggle('is-off', !li.querySelector('[data-tvfbt-toggle]').checked); });
      totalEl.textContent = money(now);
      /* crossed-out bundle total only (no "You save" line), shown from the same minimum % as every sale price (kg-sale.js) */
      var minPct = window.KGSale && KGSale.minPct ? KGSale.minPct() : 10;
      var showWas = was > now && Math.floor(((was - now) / was) * 100) >= minPct;
      wasEl.hidden = !showWas;
      wasEl.textContent = showWas ? money(was) : '';
      label.textContent = labelTpl.replace('[n]', sel.length === 1 ? '1 item' : sel.length + ' items');
      if (/\[n\]/.test(labelTpl) === false && sel.length) label.textContent = labelTpl;
    }

    items.forEach(function (li) {
      var cb = li.querySelector('[data-tvfbt-toggle]');
      cb.addEventListener('change', update);
      var vs = li.querySelector('[data-tvfbt-variant]');
      if (vs) vs.addEventListener('change', function () {
        var o = vs.options[vs.selectedIndex];
        li.dataset.variant = o.value;
        li.dataset.price = o.dataset.price;
        li.dataset.compare = o.dataset.compare;
        li.querySelector('[data-tvfbt-now]').textContent = money(+o.dataset.price);
        update();
      });
    });

    /* main item follows the product form's variant picker */
    var main = root.querySelector('[data-tvfbt-main]');
    if (main && typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        main.dataset.variant = v.id;
        main.dataset.price = v.price;
        main.dataset.compare = v.compare_at_price > v.price ? v.compare_at_price : v.price;
        var available = v.available !== false;
        main.classList.toggle('is-unavailable', !available);
        update();
      });
    }

    btn.addEventListener('click', function () {
      var sel = chosen();
      if (!sel.length || btn.disabled) return;
      if (main && main.classList.contains('is-unavailable')) {
        msg.textContent = kgT('option_sold_out', 'This option is sold out. Pick another option above.');
        return;
      }
      btn.disabled = true;
      btn.classList.add('is-loading');
      msg.textContent = '';

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var payload = { items: sel.map(function (li) { return { id: +li.dataset.variant, quantity: 1 }; }) };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      url = url.replace(/\.js\.js$/, '.js');

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || kgT('could_not_add', 'Could not add to cart'));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tv-fbt', cartData: res }); } catch (e) {}
          }
          if (cart && typeof cart.renderContents === 'function' && res.sections) {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
            cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          msg.textContent = kgT('added', 'Added to your cart.');
        })
        .catch(function (e) { msg.textContent = e.message; })
        .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });

    update();
  }

  function boot() { document.querySelectorAll('[data-tvfbt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
